export default "__VITE_ASSET__719b5fd8__"